import { ErrorIcon } from '@p2p/assets/svg';
import { Button, Typography } from '@p2p/components';
import {
  MainContainer,
  MainPageDispute,
  MatchingPageDispute,
  PaymentId,
} from '@p2p/entities/payment';
import { usePaymentTemplate } from '@p2p/entities/templates';
import { MSP_PAGE, PROOF_PAGE } from '@p2p/shared/constants';
import { useEffect, useState } from 'react';

import styles from './PaymentWarning.module.scss';
import { PaymentWarningProps } from './PaymentWarning.types';

// Страницы, где диспут открывается с одним PDF-чеком до 2 МБ (форма MatchingPageDispute).
// P2P-2880: proof_page — та же форма, что у msp_page, со своим маршрутом успеха.
const PDF_DISPUTE_PAGE_PATHS: Record<string, string> = {
  msp_page: MSP_PAGE,
  proof_page: PROOF_PAGE,
};

export const PaymentWarning = ({ order, pageSettings }: PaymentWarningProps) => {
  const { setIsShowSteps } = usePaymentTemplate();
  const [isSupport, setIsSupport] = useState(false);

  useEffect(() => {
    setIsShowSteps(false);

    return () => {
      setIsShowSteps(true);
    };
  }, [setIsShowSteps]);

  const pdfDisputePagePath = PDF_DISPUTE_PAGE_PATHS[order.payment_form];

  if (isSupport && pdfDisputePagePath) {
    return (
      <MatchingPageDispute
        comeback={() => setIsSupport(false)}
        successPath={`${pdfDisputePagePath}/${order.id}/dispute/success`}
      />
    );
  } else if (isSupport) {
    return <MainPageDispute comeback={() => setIsSupport(false)} />;
  }

  return (
    <MainContainer maxWidth="460px" className={styles.wrapper}>
      <div className={styles.container}>
        <ErrorIcon />
        <Typography variant="h1" color="heading">
          Мы не нашли Ваш перевод
        </Typography>
        <Typography variant="text-l-medium" color="description" className={styles.description}>
          {`Статус платежа можно уточнить через\nслужбу поддержки казино, указав его ID.`}
        </Typography>
        <PaymentId id={order.id} />
      </div>
      <div className={styles.actions}>
        {pageSettings.allow_create_dispute && (
          <Button onClick={() => setIsSupport(true)} fullWidth>
            Свяжитесь с нами
          </Button>
        )}
        <Button
          onClick={() => window.location.replace(order.merchant_failed_page)}
          variant={pageSettings.allow_create_dispute ? 'outlined' : 'default'}
          fullWidth
        >
          Вернуться на сайт
        </Button>
      </div>
    </MainContainer>
  );
};
